// func
export function getActivitySlotInfo(language: string, activitySlot: any): any {
    const [activityLabel, time] = activitySlot.activity_label.split('-');
    const [dayLabel, slotStart] = time.split('_');
    const slotDuration = activitySlot?.duration_min ?? 0;
    const slotEnd = getHumanHour(language, slotStart, parseInt(slotDuration, 10), true);

    return {
      activitySlotLabel: activitySlot.activity_label,
      activityLabel,
      dayLabel,
      slotStart,
      start: getHumanHour(language, slotStart),
      slotDuration,
      slotEnd,
      end: getHumanHour(language, slotEnd)
    };
  }

export function getHumanHour(language: string, hour_id: string | number, durationMinutes?: number, rawReturn?: boolean): string {
    // Ensure hour_id is a string in HHMM format
    let hourStr = hour_id.toString().padStart(4, '0');
    let hours = parseInt(hourStr.substring(0, 2), 10);
    let minutes = parseInt(hourStr.substring(2, 4), 10);
  
    // Add duration if provided
    if (durationMinutes) {
      const totalMinutes = hours * 60 + minutes + durationMinutes;
      hours = Math.floor(totalMinutes / 60);
      minutes = totalMinutes % 60;
    }

    if(rawReturn) return `${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}`;
  
    const formattedHHMM = `${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}`;
  
    switch (language) {
      case "english":
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? "am" : "pm";
        return minutes === 0
          ? `${hour12}${ampm}`
          : `${hour12}:${minutes.toString().padStart(2, '0')}${ampm}`;
  
      default:
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
  }

export function getPasses(skipasses: String[], skipassMap: any, skipassResponse: any, days: any): any[]{
    let userPasses = [];
    skipasses.map(uPass => {
      const [type, dayNumber, startingDay] = uPass.split('-');
      const sMap = skipassMap.find(passType => passType.label === type);
      const sDyn = skipassResponse.find(skiPass => uPass === skiPass.skipass_label)
      let offset = 0;
      if (startingDay){
        offset = days.findIndex(day => day.label === startingDay)
      }
      for (let i = 0 ; i<parseInt(dayNumber, 10) ; i++){
        days[offset + i].selectedPassType = type;
      }
      const pass = {
        name: sMap?.name ?? type,
        days: dayNumber,
        firstDay: days[offset].name ?? startingDay,
        price: sDyn?.price ?? 0
      }
      userPasses.push(pass);
    });
    return userPasses;
  }

export function getEquipments(equipments: String[], equipmentFront: any, equipmentResponse: any, days: any): any[]{
    let userEquipment = [];
    equipments.map(equipmentFullLabel => {

      // Parse format: ski_performance_skiOnly_3-male-fri_sat_sun-helmetL
      const section = equipmentFullLabel.split('-');
      const equipmentLabel = section[0];

      if (equipmentLabel != "none") {
        const parts = section[0].split('_');
        if (parts.length != 4 || section.length < 2) {
          return;
        }

        const selectedType = parts[0]; // Use label directly
        const selectedLevel = parts[1];
        const selectedPackage = parts[2];

        const selectedGender = section[1];

        const selectedDays = section[2].split('_');
        const dayNumber = selectedDays.length;
        
        // Find dynamic pricing/data if available
        const equipmentDynamic = equipmentResponse.find(eq => 
          eq.equipment_label === equipmentLabel
        );
        const equipment = {
          id: equipmentFullLabel,
          name: equipmentFront["userEquipment"]["slider"],
          message: `${equipmentFront[selectedType]} - ${equipmentFront[selectedLevel]} - ${equipmentFront[selectedPackage]} - ${equipmentFront[selectedGender]}`,
          days: dayNumber,
          totalPrice: (equipmentDynamic?.price ?? 0)
        };
        userEquipment.push(equipment);
      }

      if (section[section.length-1].startsWith("helmet")) {
        const helmet = {
          id: equipmentFullLabel,
          name: equipmentFront["userEquipment"]["helmet"],
          message: `${equipmentFront["helmetSizeChoice"]} ${section[section.length-1].replace("helmet", "")}`,
          days: "∞",
          totalPrice: 0
        };
        userEquipment.push(helmet);
      }
    });
    return userEquipment;
  }

export function getRolesFromJWT(token): string[]{
  try {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
    const claims = JSON.parse(payloadJson);
    const roles = claims.roles || (claims.claims && claims.claims.roles) || [];
    return roles
  } catch (e) {
    console.error("Failed to decode token:", e);
    return [];
  }
}